import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'ison';
const args = {};

export class Ison extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
